module.exports = __webpack_public_path__ + "static/img/アセット 33@2x.955e1a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 33@2x.png
// module id = DhGw
// module chunks = 1